import ExcelJS from 'exceljs';

/**
 * Client-side Excel export shared by grid views (MTO, Part Rate DB, ...).
 *
 * @param {Object} opts
 * @param {Array<{key:string,label:string,type?:string}>} opts.columns - columns to export (order preserved)
 * @param {Array<Object>} opts.rows - data rows (omit / empty for a blank template)
 * @param {string} opts.fileName - download file name (".xlsx" appended if missing)
 * @param {string} [opts.sheetName='Sheet1']
 */
export async function exportToExcel({ columns, rows = [], fileName = 'export.xlsx', sheetName = 'Sheet1' }) {
  const workbook = new ExcelJS.Workbook();
  const ws = workbook.addWorksheet(sheetName.substring(0, 31) || 'Sheet1');

  ws.columns = columns.map((c) => ({
    header: c.label || c.key,
    key: c.key,
    width: Math.min(40, Math.max(10, (c.label || c.key).length + 4)),
  }));

  // Header styling
  const headerRow = ws.getRow(1);
  headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F46E5' } };
  headerRow.alignment = { vertical: 'middle' };

  (rows || []).forEach((row) => {
    const out = {};
    columns.forEach((c) => {
      let v = row[c.key];
      if (v === undefined || v === null || v === '') { out[c.key] = null; return; }
      if (c.type === 'number') {
        const n = Number(v);
        out[c.key] = Number.isFinite(n) ? n : v;
      } else if (c.type === 'date') {
        const d = new Date(v);
        out[c.key] = isNaN(d.getTime()) ? v : d;
      } else {
        out[c.key] = v;
      }
    });
    ws.addRow(out);
  });

  ws.views = [{ state: 'frozen', ySplit: 1 }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export default exportToExcel;
